// extracted by mini-css-extract-plugin
export default {"category-links":"PbxmmV","category-links__links-wrapper":"n5QiYm","category-links__link":"UyXc_F"};